import React from "react";
import winnersImg from "../../../Images/common_Image.jpg";
import winnerAboutImg from "../../../Images/Group 40 (2).png";
import img from "../../../Images/Rectangle 16.png";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "./newAboutWinners.css";

const NewAboutWinner = () => {
  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className="modernwinner-main-section">

        <div className="modernwinner-glow-one"></div>
        <div className="modernwinner-glow-two"></div>

        <div className="modernwinner-container">

          {/* TOP */}

          <div className="modernwinner-top-wrapper">

            <div className="modernwinner-top-left">

              <span className="modernwinner-subtitle">
                About Winners
              </span>

              <h2 className="modernwinner-title">
                Creating smarter real estate experiences with premium living,
                trusted investments & modern communities.
              </h2>

              <p className="modernwinner-description">
                Winners is redefining modern property discovery through curated
                projects, transparent investment opportunities, and futuristic
                community experiences across top cities.
              </p>

              <div className="modernwinner-btns">
                <button
                  className="modernwinner-primary-btn"
                  onClick={() => navigate("/aboutus")}
                >
                  Explore More
                </button>

                <button
                  className="modernwinner-secondary-btn"
                  onClick={() => navigate("/propertylist")}
                >
                  View Properties
                </button>
              </div>

            </div>

            {/* VIDEO CARD */}

            <div className="modernwinner-video-card">

              <img
                src={winnersImg}
                alt=""
                className="modernwinner-video-image"
              />

              <div className="modernwinner-video-overlay"></div>

              <div className="modernwinner-play-btn">
                <i className="fa-solid fa-play"></i>
              </div>

              <div className="modernwinner-video-content">
                <span>Featured Experience</span>
                <h4>Luxury spaces crafted for future living</h4>
              </div>

            </div>

          </div>

          {/* BOTTOM */}

          <div className="modernwinner-bottom-wrapper">

            {/* LEFT IMAGE */}

            <div className="modernwinner-image-side">

              <div className="modernwinner-image-box">
                <img src={winnerAboutImg} alt="" />
              </div>

              <div className="modernwinner-floating-card">
                <h3>20+</h3>
                <p>Premium Cities</p>
              </div>

            </div>

            {/* RIGHT CONTENT */}

            <div className="modernwinner-content-side">

              <div className="modernwinner-slider-wrapper">

                <Slider {...settings}>

                  <div>
                    <div className="modernwinner-slider-card">

                      <div className="modernwinner-card-icon">
                        <i className="fa-solid fa-building"></i>
                      </div>

                      <h3>
                        Smart Urban Communities
                      </h3>

                      <p>
                        We design premium residential ecosystems focused on
                        comfort, accessibility, modern lifestyle and strong
                        long-term value.
                      </p>

                      <button
                        className="modernwinner-card-btn"
                        onClick={() => navigate("/communitylist")}
                      >
                        Explore Communities
                      </button>

                    </div>
                  </div>

                  <div>
                    <div className="modernwinner-slider-card image-card">

                      <img src={img} alt="" />

                      <div className="modernwinner-image-card-content">
                        <span>Starting From</span>
                        <h3>$256K</h3>

                        <button
                          className="modernwinner-card-btn"
                          onClick={() => navigate("/propertylist")}
                        >
                          Browse Properties
                        </button>
                      </div>

                    </div>
                  </div>

                </Slider>

              </div>

              {/* STATS */}

              <div className="modernwinner-stats-wrapper">

                <div className="modernwinner-stat-box">
                  <h3>1L+</h3>
                  <p>Verified Listings</p>
                </div>

                <div className="modernwinner-stat-box">
                  <h3>1600+</h3>
                  <p>Localities</p>
                </div>

                <div className="modernwinner-stat-box">
                  <h3>25Cr+</h3>
                  <p>Property Value</p>
                </div>

              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default NewAboutWinner;